import React from 'react';

import EventDateFilter from '../Filters/EventDateFilter';
import EventsMoreMobileFilter from '../Filters/EventsMoreMobileFilter';
import EventTypeFilter from '../Filters/EventTypeFilter';
import GenderFilter from '../Filters/GenderFilter';
import EventRegionFilter from '../Filters/EventRegionFilter';

import { minUtrValue, maxUtrValue } from '../../../utils/constants';
import { doesFilterHaveValue } from '../../../utils/search';
import EventsMoreDesktopFilter from '../Filters/EventsMoreDesktopFilter';
import EventsUtrFilter from '../Filters/EventsUtrFilter';
import EventAgeRangeFilter from '../Filters/EventAgeRangeFilter';

const JuniorCircuitFilters = (props) => {
    const {
        search,
        handleFilterClick,
        userLoggedIn,
        state,
        _this,
        filterInputs,
        searchTypes,
        hideFilters,
        regionSearch,
        ageDisplay,
    } = props;

    const { filters = {} } = search;

    const { eventTypes, eventUtrTypes, eventTeamTypes, genders, prizeMoneyMin, prizeMoneyMax } = filters;

    // takes an object from the nested filters and see if it has a value
    const isEventTypeSelected = doesFilterHaveValue(eventTypes);
    const isEventUtrTypeSelected = doesFilterHaveValue(eventUtrTypes);
    const isEventTeamTypeSelected = doesFilterHaveValue(eventTeamTypes);
    const isGenderSelected = doesFilterHaveValue(genders);

    const isMobileMoreFilterActive =
        search.filters &&
        (isEventTypeSelected ||
          isEventUtrTypeSelected ||
          prizeMoneyMin > 1 ||
          prizeMoneyMax < searchTypes.prizeMoneyValues.length ||
          isEventTeamTypeSelected ||
          isGenderSelected ||
          filters.utrMin > minUtrValue ||
          filters.utrMax < maxUtrValue);

    const isDesktopMoreFilterActive =
        search.filters &&
        (filters.utrMin > minUtrValue ||
          filters.utrMax < maxUtrValue ||
          isEventTeamTypeSelected ||
          isGenderSelected);

    const commonFilterProps = {
        filters,
        filterInputs,
        handleFilterClick,
        filterModal: state.filterModal,
        closeModals: _this.closeModals,
        handleFilterSubmit: _this.handleFilterSubmit,
        clearFilters: _this.clearFilters,
        handleFilterUpdate: _this.handleFilterUpdate,
    };

    return (
        <React.Fragment>
            <EventDateFilter
                {...commonFilterProps}
                data-testid="search.junior-circuits.filter.date"
            />
            {regionSearch ? (
                <React.Fragment>
                    <EventRegionFilter
                        {...commonFilterProps}
                        searchTypes={searchTypes}
                        data-testid="search.junior-circuits.filter.region"
                    />
                    {userLoggedIn && (
                        <React.Fragment>
                            <EventsUtrFilter
                                {...commonFilterProps}
                                searchTypes={searchTypes}
                                data-testid="search.junior-circuits.filter.utr"
                            />
                            <EventAgeRangeFilter
                                {...commonFilterProps}
                                userLoggedIn={userLoggedIn}
                                ageDisplay={ageDisplay}
                                data-testid="search.junior-circuits.filter.age-range"
                            />
                        </React.Fragment>
                    )}
                    <GenderFilter
                        {...commonFilterProps}
                        desktopOnly={true}
                        data-testid="search.junior-circuits.filter.gender"
                    />
                    <EventTypeFilter
                        {...commonFilterProps}
                        searchTypes={searchTypes}
                        desktopOnly={true}
                        data-testid="search.junior-circuits.filter.event-type"
                    />
                </React.Fragment>
            ) : (
                <EventsMoreDesktopFilter
                    {...commonFilterProps}
                    searchTypes={searchTypes}
                    eventsMoreDesktopFiltersAreActive={isDesktopMoreFilterActive}
                    desktopOnly={true}
                    data-testid="search.junior-circuits.filter.more-desktop"
                />
            )}
            {userLoggedIn && (
                <EventsMoreMobileFilter
                    {...commonFilterProps}
                    searchTypes={searchTypes}
                    eventsMoreMobileFiltersAreActive={isMobileMoreFilterActive}
                    userLoggedIn={userLoggedIn}
                    hideFilters={hideFilters}
                    state={state}
                    mobileOnly={true}
                    data-testid="search.junior-circuits.filter.more-mobile"
                />
            )}
        </React.Fragment>
    );
};

export default JuniorCircuitFilters;
